import BusRatesTable from './BusRatesTable';
import './smallkey.css';
import { Helmet } from 'react-helmet';
import FaqSection from './FAQKeyword';
import FleetHighway from './FleetHighway';
import ContactShowcase from './phoneToWhatsApp';
import TestimonialSectionKeyword from './TestimonialSectionKeyword';

function Punetomahabalehswarcabs() {



  const cardData =
  {
    keyword: 'Pune to Mahabaleshwar Cabs',
    heading: 'Sai Trupti Cabs: Pune to Mahabaleshwar Cabs',
    headingDescription: 'Sai Trupti Cabs offers reliable and comfortable Pune to Mahabaleshwar cab services, designed to make your inter-city journey smooth and stress-free. Our fleet includes well-maintained, air-conditioned Sedans, SUVs, and Premium vehicles — all equipped with clean interiors and ample luggage space for your travel and sightseeing needs. Every journey is driven by a professional, background-verified chauffeur who ensures punctual pickup in Pune, courteous service, and safe, smooth driving all the way to Mahabaleshwar. With transparent one-way fares, flexible booking options (one-way or round-trip), and 24×7 customer support, Sai Trupti Cabs makes your travel from Pune to Mahabaleshwar convenient, affordable and worry-free.',

    top: 'Top Places to Visit in Mahabaleshwar with Sai Trupti Cabs',

"topPlaces": [
  {
    "title": "Mahabaleshwar Temple",
    "description": "The Mahabaleshwar Temple is the spiritual heart of Mahabaleshwar, dedicated to Lord Shiva under the name ‘Mahabali’. Set amidst the Sahyadri range, the 16th-century Hemadpanthi style shrine houses a self-manifested lingam revered for centuries. Pilgrims believe visiting this temple brings cleansing and divine favour, and the temple’s serene high-altitude setting adds to its aura. Encircled by lush forests and misty peaks, this sacred site offers both faith and tranquillity. Whether for devotion or contemplation, the Mahabaleshwar Temple remains a timeless landmark in this hill station."
  },
  {
    "title": "Arthur’s Seat",
    "description": "Arthur’s Seat is the most famous lookout point in Mahabaleshwar, perched high above the valleys and known as the ‘Queen of Points’. From this vantage, visitors gaze down on the winding Savitri River and deep forested ravines. Local legend says the name comes from Arthur Malet, who would’ sit here overlooking the valley following personal tragedy. The viewpoint delivers breathtaking panoramas, dramatic rock formations and a sense of elevation that energises body and spirit. For photographers and nature lovers, Arthur’s Seat is a must-visit highlight."
  },
  {
    "title": "Venna Lake",
    "description": "Nestled in the heart of Mahabaleshwar, Venna Lake is a man-made waterbody created in the 1840s and now a favourite recreational spot. Surrounded by trees, cafés and horse-rides, the lake offers paddle-boats on tranquil waters and relaxed sunset views. Families stroll along its banks, children ride the toy train, and couples savour fresh strawberries from nearby stalls. The gentle hum of activity set against the green hills creates a soothing backdrop for a leisurely afternoon. Venna Lake beautifully balances natural calm and tourist ease."
  },
  {
    "title": "Elephant’s Head Point",
    "description": "Elephant’s Head Point is a striking viewpoint where a natural rock formation resembles an elephant’s head and trunk extending into the valley — hence its name. From the edge, one looks across dramatic ridges, wide forests and the Sahyadri splendour unfolding in layers. Best enjoyed at sunrise or sunset, the site promises cinematic vistas and crisp mountain air. It’s also called Needle-Hole Point because of a narrow gap in the rock through which the view extends. A visit here is both thrilling and meditative in nature’s grandeur."
  },
  {
    "title": "Mapro Garden & Strawberry Farms",
    "description": "Mapro Garden and the surrounding strawberry farms define Mahabaleshwar’s modern charm and agricultural identity. Set amidst rolling hills, Mapro offers chocolate factory tours, fresh shakes, and the flavour of locally grown strawberries that the region is famous for. Visitors wander the orchards, sample jams and pick fresh produce, blending gastronomic pleasure with scenic ambiance. During the strawberry season, the air fills with the scent of fruit and laughter of visitors. It’s a delightful stop that combines taste, leisure and hillside aesthetics."
  },
  {
    "title": "Wilson Point (Sunrise Point)",
    "description": "Wilson Point, the highest viewpoint in Mahabaleshwar, stands at an altitude of around 1,439 metres and offers spectacular sunrise vistas over the Sahyadri range. Early risers are rewarded with violet dawn skies, a sense of quietude and panoramic expanses of hills rolling into the distance. The wooden watch-towers and open plateau create a space for reflection and awe. With the chill mountain air and wide open horizon, Wilson Point encapsulates the serene beauty of Mahabaleshwar in its purest form."
  },
  {
    "title": "Lingmala Waterfall",
    "description": "Tucked away in the forests near Mahabaleshwar, Lingmala Waterfall is a majestic 600-foot cascade that becomes a roaring torrent during the monsoon and a graceful stream in the drier months. The forest walk, the mist rising off the fall, and the lush greenery around provide an adventurous escape from the hill-station bustle. Visitors climb stone steps, breathe in fresh air and feel the spray of falling water. Lingmala is where nature shows its power and calm at once — perfect for seekers of both thrill and peace."
  },
  {
    "title": "Krishnabai Temple & Source of River Krishna",
    "description": "The Krishnabai Temple is a sacred shrine believed to mark the origin of the mighty River Krishna. Located near Mahabaleshwar’s old “Kshetra”, this temple blends myth, architecture and landscape in a profound way. Pilgrims come to offer their prayers, and travellers pause to reflect at the river’s source surrounded by cool woods and clean water flow. The site underscores Mahabaleshwar’s unique role — not just as a hill station, but as the birthplace of rivers and legends. For devotees and wanderers alike it holds deep significance."
  },
  {
    "title": "Old Mahabaleshwar & Panchganga Temple",
    "description": "Old Mahabaleshwar, with its quiet lanes and heritage temples, includes the Panchganga Temple — where five rivers are said to meet at their source. The area exudes an old-world charm that contrasts with the tourist bustle of the newer sections. Visitors wander among historic stones, shady trees and sacred steps, feeling the hush of devotion and centuries. The architecture, mythology and green surroundings create a layered experience: spiritual, historical and scenic all at once. It’s ideal for those seeking depth beyond view-points."
  },
  {
    "title": "Table Land & Viewpoints Beyond",
    "description": "Table Land, the vast volcanic plateau near Mahabaleshwar, is Asia’s second-largest of its kind and offers wide open terrain, dramatic cliffs and sweeping drop-offs into valleys. Walks along the edge, vantage points like Lodwick and Elphinstone, and skies layered with cloud and hill-tops create an unforgettable atmosphere. Ideal for trekking, stargazing and picnicking, the location invites you to stretch your senses under open skies. At dusk, the horizon seems infinite, capturing the expansive spirit of Mahabaleshwar."
  }
],



"services": [
  {
    "name": "Pune to Mahabaleshwar Cabs",
    "description": "Book comfortable Pune to Mahabaleshwar cabs with reliable service, AC/non-AC options, experienced drivers, and flexible pickup/drop points. Perfect for family trips, weekend getaways, or group travel with affordable fares and easy online booking."
  },
  {
    "name": "Pune to Mahabaleshwar Taxi Service",
    "description": "Hire a taxi from Pune to Mahabaleshwar for a smooth, scenic ride through the Western Ghats. Enjoy well-maintained vehicles, courteous chauffeurs, flexible timings, and transparent pricing for one-way or round-trip travel."
  },
  {
    "name": "Pune to Mahabaleshwar Car Hire",
    "description": "Rent a car from Pune to Mahabaleshwar for comfortable and personalized travel. Choose from Sedans, SUVs, and luxury cars with AC/non-AC options, professional drivers, luggage assistance, and flexible route options."
  },
  {
    "name": "Pune to Mahabaleshwar AC Cab",
    "description": "Travel comfortably with AC cab service from Pune to Mahabaleshwar. Enjoy clean, air-conditioned vehicles, skilled drivers, flexible pickups, and safe travel through the hills — ideal for families, couples, and tourists."
  },
  {
    "name": "Pune to Mahabaleshwar Non AC Cab",
    "description": "Affordable non-AC cab service from Pune to Mahabaleshwar with reliable drivers, well-maintained cars, and flexible pickup/drop points. Perfect for travelers looking for budget-friendly hill station rides."
  },
  {
    "name": "Pune to Mahabaleshwar Innova Cab",
    "description": "Spacious and comfortable Innova cabs for Pune to Mahabaleshwar trips. Perfect for families or groups, featuring AC comfort, ample legroom, experienced drivers, and smooth travel on ghat roads for a relaxing journey."
  },
  {
    "name": "Pune to Mahabaleshwar Ertiga Cab",
    "description": "Book an Ertiga cab from Pune to Mahabaleshwar for affordable group travel. Enjoy AC/non-AC options, comfortable seating, luggage space, and experienced drivers who ensure a safe and enjoyable hill station ride."
  },
  {
    "name": "Luxury Cab Pune to Mahabaleshwar",
    "description": "Travel in style with luxury cab service from Pune to Mahabaleshwar featuring premium Sedans and SUVs. Ideal for VIP guests, corporate executives, or honeymoon trips — offering luxury interiors, AC service, and professional chauffeurs."
  },
  {
    "name": "Affordable Pune to Mahabaleshwar Cab",
    "description": "Get pocket-friendly Pune to Mahabaleshwar cab services with transparent fares, AC/non-AC options, professional drivers, flexible timings, and easy booking. Perfect for solo travelers, students, and small families."
  },
  {
    "name": "Pune to Mahabaleshwar Outstation Cab",
    "description": "Reliable outstation cab service from Pune to Mahabaleshwar ideal for weekend trips, sightseeing, or long stays. Choose from a variety of vehicles, enjoy AC/non-AC comfort, flexible booking, and safe travel with experienced drivers."
  },
  {
    "name": "Pune to Mahabaleshwar One Way Cab",
    "description": "Book one-way cabs from Pune to Mahabaleshwar at affordable rates. Enjoy point-to-point travel, clean vehicles, professional drivers, and flexible pickup options — perfect for travelers heading to the hill station without return plans."
  },
  {
    "name": "Pune to Mahabaleshwar Drop Cab",
    "description": "One-way drop cab service from Pune to Mahabaleshwar with flexible timings, AC/non-AC options, professional drivers, and smooth travel experience. Best for travelers looking for comfortable one-time transfers."
  },
  {
    "name": "Pune to Mahabaleshwar Online Booking",
    "description": "Book your Pune to Mahabaleshwar cab online with instant confirmation, secure payment options, and transparent fares. Choose from Sedans, Ertigas, and Innovas for a convenient and stress-free hill station ride."
  },
  {
    "name": "Corporate Cab Pune to Mahabaleshwar",
    "description": "Premium corporate cab hire from Pune to Mahabaleshwar offering executive vehicles, professional chauffeurs, flexible travel schedules, and business-class comfort. Ideal for conferences, retreats, and client visits."
  },
  {
    "name": "Wedding Cab Pune to Mahabaleshwar",
    "description": "Hire elegant wedding cabs from Pune to Mahabaleshwar with luxury interiors, AC comfort, professional chauffeurs, and on-time pickups. Perfect for bride/groom transfers, guests, or event logistics with complete reliability."
  }
],
"tableData": [
  ["Pune to Mahabaleshwar Cabs", "Pune to Mahabaleshwar Taxi Service"],
  ["Pune to Mahabaleshwar Car Hire", "Pune to Mahabaleshwar AC Cab"],
  ["Pune to Mahabaleshwar Non AC Cab", "Pune to Mahabaleshwar Innova Cab"],
  ["Pune to Mahabaleshwar Ertiga Cab", "Luxury Cab Pune to Mahabaleshwar"],
  ["Affordable Pune to Mahabaleshwar Cab", "Pune to Mahabaleshwar Outstation Cab"],
  ["Pune to Mahabaleshwar One Way Cab", "Pune to Mahabaleshwar Drop Cab"],
  ["Pune to Mahabaleshwar Online Booking", "Corporate Cab Pune to Mahabaleshwar"],
  ["Wedding Cab Pune to Mahabaleshwar", ""]
],


"whychoose": [
  {
    "WhyChooseheading": "Pune to Mahabaleshwar Cabs",
    "WhyChoosedescription": "Sai Trupti Cabs  offers reliable and comfortable cab services from Pune to Mahabaleshwar — perfect for hill station trips, family outings, and leisure travel."
  },
  {
    "WhyChooseheading": "Transparent & Competitive Fare",
    "WhyChoosedescription": "Get clear one-way fare estimates for Pune to Mahabaleshwar cabs, starting at affordable rates depending on the car type — no hidden charges or last-minute surprises."
  },
  {
    "WhyChooseheading": "Wide Range of Vehicle Options",
    "WhyChoosedescription": "Choose from hatchbacks, sedans, SUVs, or premium cars to suit your group size, luggage, and comfort preferences for the Pune–Mahabaleshwar route."
  },
  {
    "WhyChooseheading": "Professional & Experienced Drivers",
    "WhyChoosedescription": "Our courteous and skilled drivers are familiar with the Pune to Mahabaleshwar route, ensuring a safe, smooth, and timely journey through hilly terrain."
  },
  {
    "WhyChooseheading": "Flexible Pickup & Drop Locations",
    "WhyChoosedescription": "We provide pickups from anywhere in Pune (city, airport, or suburbs) and drop-offs at Mahabaleshwar hotels, resorts, or residences."
  },
  {
    "WhyChooseheading": "Clean & Well-Maintained Vehicles",
    "WhyChoosedescription": "All our cabs are regularly serviced, sanitized, and maintained to ensure comfort and reliability for your scenic journey."
  },
  {
    "WhyChooseheading": "24/7 Booking & Customer Support",
    "WhyChoosedescription": "Our dedicated team is available round-the-clock to assist with bookings, route planning, or any travel queries."
  },
  {
    "WhyChooseheading": "Hassle-Free Booking Process",
    "WhyChoosedescription": "Book your Pune to Mahabaleshwar cab easily via call, WhatsApp, or our website — with instant confirmation and prompt vehicle dispatch."
  }
]






















  }

const faqData = [
  {
    question: 'Does Sai Trupti Cabs  offer Pune to Mahabaleshwar cab services?',
    answer: 'Yes, Sai Trupti Cabs  provides reliable and affordable Pune to Mahabaleshwar cab services for one way, round trips, and weekend getaways.',
  },
  {
    question: 'How can I book a Pune to Mahabaleshwar cab with Sai Trupti Cabs?',
    answer: 'You can easily book your Pune to Mahabaleshwar cab through our website, mobile app, or by contacting our 24×7 customer support team for quick assistance.',
  },
  {
    question: 'What types of cabs are available from Pune to Mahabaleshwar?',
    answer: 'We offer a variety of well-maintained vehicles including hatchbacks, sedans, SUVs, Ertiga, Innova Crysta, and tempo travellers—ideal for families, couples, and groups.',
  },
  {
    question: 'Are the drivers professional and experienced for Pune to Mahabaleshwar routes?',
    answer: 'Yes, all our drivers are experienced, courteous, and well-versed with the ghat routes between Pune and Mahabaleshwar, ensuring a safe and scenic drive.',
  },
  {
    question: 'Can I hire a cab for sightseeing in and around Mahabaleshwar?',
    answer: 'Certainly. We offer full-day sightseeing cab packages for popular Mahabaleshwar attractions like Venna Lake, Mapro Garden, Elephant’s Head Point, and Panchgani.',
  },
  {
    question: 'Is the Pune to Mahabaleshwar cab service available 24×7?',
    answer: 'Yes, Sai Trupti Cabs offers 24×7 Pune to Mahabaleshwar cab services so you can plan your trip anytime that suits your schedule.',
  },
  {
    question: 'What are the Pune to Mahabaleshwar cab fares?',
    answer: 'Our Pune to Mahabaleshwar cab fares start from ₹2,500 for sedans and ₹3,500–₹4,500 for SUVs or Innova Crysta, depending on your vehicle preference and trip plan.',
  },
  {
    question: 'What payment options are available for Pune to Mahabaleshwar cab bookings?',
    answer: 'We accept payments via UPI, credit/debit cards, digital wallets, and bank transfers for a smooth and secure booking process.',
  },
  {
    question: 'What safety and hygiene protocols are followed for Pune to Mahabaleshwar cabs?',
    answer: 'All vehicles are sanitized before every trip, and our drivers adhere to strict hygiene and safety measures to ensure a comfortable and worry-free journey.',
  },
  {
    question: 'Is customer support available during the Pune to Mahabaleshwar cab ride?',
    answer: 'Yes, our dedicated 24×7 customer support team is available to assist you throughout your Pune to Mahabaleshwar journey.',
  },
];

const testimonials = [
  {
    id: 1,
    name: 'Mr. Amit Deshpande',
    feedback: 'Our Pune to Mahabaleshwar trip with Sai Trupti Cabs was amazing. The driver was friendly, and the car was clean and comfortable.',
    rating: 5,
  },
  {
    id: 2,
    name: 'Ms. Rutuja Pawar',
    feedback: 'Sai Trupti Cabs provided an excellent Pune to Mahabaleshwar cab service. The ride was smooth, on time, and hassle-free.',
    rating: 5,
  },
];





















































































  const Images = [
  { place: "/images/keyword/1.jpg", text: "Pune to Mumbai Cab", link: "Pune-to-Mumbai-Cab" },
  { place: "/images/keyword/2.jpg", text: "Pune to Mumbai Airport Cab", link: "Pune-to-Mumbai-Airport-Cab" },
  { place: "/images/keyword/3.jpg", text: "Pune to Mumbai International Airport Cab", link: "Pune-to-Mumbai-International-Airport-Cab" },
  { place: "/images/keyword/4.jpg", text: "Pune to Mumbai One Way Cab", link: "Pune-to-Mumbai-One-Way-Cab" },
  { place: "/images/keyword/5.jpg", text: "Pune Mumbai Car Hire", link: "Pune-Mumbai-Car-Hire" },
  { place: "/images/keyword/6.jpg", text: "Pune to Mumbai Taxi Fare", link: "Pune-to-Mumbai-Taxi-Fare" },
  { place: "/images/keyword/7.jpg", text: "Pune to Mumbai Online Cab Booking", link: "Pune-to-Mumbai-Online-Cab-Booking" },
  { place: "/images/keyword/8.jpg", text: "Pimpri Chinchwad to Mumbai Cab", link: "Pimpri-Chinchwad-to-Mumbai-Cab" },
  { place: "/images/keyword/9.jpg", text: "Baner to Mumbai Cabs", link: "Baner-to-Mumbai-Cabs" },
  { place: "/images/keyword/10.jpg", text: "Hinjewadi to Mumbai Cab", link: "Hinjewadi-to-Mumbai-Cab" },
  { place: "/images/keyword/11.jpg", text: "Pimple Saudagar to Mumbai Cab Service", link: "Pimple-Saudagar-to-Mumbai-Cab-Service" },
  { place: "/images/keyword/12.jpg", text: "Wakad to Mumbai Cab", link: "Wakad-to-Mumbai-Cab" },
  { place: "/images/keyword/13.jpg", text: "Hadapsar to Mumbai Cab", link: "Hadapsar-to-Mumbai-Cab" },
  { place: "/images/keyword/14.jpg", text: "Kalyani Nagar to Mumbai Taxi", link: "Kalyani-Nagar-to-Mumbai-Taxi" },
  { place: "/images/keyword/15.jpg", text: "Koregaon Park to Mumbai Cab", link: "Koregaon-Park-to-Mumbai-Cab" },
  { place: "/images/keyword/16.jpg", text: "Kothrud to Mumbai Cab", link: "Kothrud-to-Mumbai-Cab" },
  { place: "/images/keyword/17.jpg", text: "Kharadi to Mumbai Cab", link: "Kharadi-to-Mumbai-Cab" },
  { place: "/images/keyword/18.jpg", text: "Shivajinagar to Mumbai Cab", link: "Shivajinagar-to-Mumbai-Cab" },
  { place: "/images/keyword/19.jpg", text: "Pune to Mumbai Ertiga Cab", link: "Pune-to-Mumbai-Ertiga-Cab" },
  { place: "/images/keyword/20.jpg", text: "Pune to Mumbai Innova Crysta Cab", link: "Pune-to-Mumbai-Innova-Crysta-Cab" },
  { place: "/images/keyword/21.jpg", text: "Pune to Mumbai Sedan Cab", link: "Pune-to-Mumbai-Sedan-Cab" },
  { place: "/images/keyword/22.jpg", text: "Kondhwa to Mumbai Cab", link: "Kondhwa-to-Mumbai-Cab" },
  { place: "/images/keyword/23.jpg", text: "Viman Nagar to Mumbai Cabs", link: "Viman-Nagar-to-Mumbai-Cabs" },
  { place: "/images/keyword/24.jpg", text: "Katraj to Mumbai Cab Service", link: "Katraj-to-Mumbai-Cab-Service" },
  { place: "/images/keyword/25.jpg", text: "Pune Station to Mumbai Cabs Service", link: "Pune-Station-to-Mumbai-Cabs-Service" },
];















const productSchema = {
  "@context": "https://schema.org",
  "@type": "Product",
  "name": "Pune to Mahabaleshwar Cabs",
  "image": "https://saitrupticabs.com/assets/images/pune-to-mahabaleshwar-cabs.jpg",
  "description": "Book reliable cabs from Pune to Mahabaleshwar for weddings, corporate trips, or personal travel. Choose AC, Non-AC, Innova, Ertiga, or luxury cabs. Affordable online booking available 24x7.",
  "brand": {
    "@type": "Brand",
    "name": "Sai Trupti Cabs"
  },
  "aggregateRating": {
    "@type": "AggregateRating",
    "bestRating": "5",
    "worstRating": "1",
    "ratingValue": "4.8",
    "ratingCount": "4800"
  },
  "offers": {
    "@type": "Offer",
    "priceCurrency": "INR",
    "price": "1599",
    "availability": "https://schema.org/InStock",
    "url": "https://saitrupticabs.com/pune-to-mahabaleshwar-cabs"
  }
};





  return (
    <div>
      <Helmet>
  <title>Pune to Mahabaleshwar Cabs | Sai Trupti Cabs</title>
  <meta 
    name="description" 
    content="Book reliable cabs from Pune to Mahabaleshwar for weddings, corporate trips, or personal travel. Choose AC, Non-AC, Innova, Ertiga, or luxury cabs. Affordable online booking available 24x7." 
  />
  <meta 
    name="keywords" 
    content="Pune to Mahabaleshwar Cabs, Pune to Mahabaleshwar Taxi Service, Pune to Mahabaleshwar Car Hire, Pune to Mahabaleshwar AC Cab, Pune to Mahabaleshwar Non AC Cab, Pune to Mahabaleshwar Innova Cab, Pune to Mahabaleshwar Ertiga Cab, Luxury Cab Pune to Mahabaleshwar, Affordable Pune to Mahabaleshwar Cab, Pune to Mahabaleshwar Outstation Cab, Pune to Mahabaleshwar One Way Cab, Pune to Mahabaleshwar Drop Cab, Pune to Mahabaleshwar Online Booking, Corporate Cab Pune to Mahabaleshwar, Wedding Cab Pune to Mahabaleshwar" 
  />
  <script type="application/ld+json">
    {JSON.stringify(productSchema)}
  </script>
</Helmet>
<section
      className="breadcrumb-section"
      style={{ backgroundImage: "url(/images/background/inner-banner-bg.png)" }}
    >
      <div className="container">
        <div className="banner-content">
          <h1> {cardData.keyword}</h1>
        </div>
      </div>
    </section>



      








      <section>
        <div className="container-fluid" >
          <div className="row container-fluid">
            <div className="col-12 col-md-7 bg-foootr">
              <img src='/images/keyword/35.jpg' alt='img' className='img-fluid' />
              <h3 className="py-1"
                style={{
                  color: '#183765', // Red color for the title 
                  textShadow: '5px 5px 10px rgba(255, 255, 255, 0.7)', // Light shadow effect
                  fontWeight: 'bold'
                }}


              >{cardData.heading} </h3><p className='fw-bold '>{cardData.headingDescription}</p>
              <div className="topPlaces">
                <p className="sectionLead">{cardData.top}</p>

                {cardData.topPlaces.map((place, index) => (
                  <article key={index} className="placeCard" tabIndex="0">
                    <span className="placeBadge">{String(index + 1).padStart(2, "0")}</span>

                    <div className="placeBody">
                      <h4 className="placeTitle">{place.title}</h4>
                      <p className="placeDesc">{place.description}</p>
                    </div>

                    <span className="placeArrow" aria-hidden>›</span>
                  </article>
                ))}
              </div>
              <div className="services-section">
                {cardData.services.map((service, index) => (
                  <div key={index} className="service-row">
                    <div className="service-icon">
                      🚖
                    </div>
                    <div>
                      <h4 className="service-title">{service.name}</h4>
                      <p className="service-desc">{service.description}</p>
                    </div>
                  </div>
                ))}
              </div>


              <table className="table table-responsive Border-key my-2">
                <tbody className=' Border-key'>
                  {cardData.tableData.map((row, rowIndex) => (
                    <tr className='Border-key ' key={rowIndex}>
                      {row.map((cell, cellIndex) => (
                        <td key={cellIndex} className=' Border-key bluecolor fw-bold' >{cell}</td>
                      ))}
                    </tr>
                  ))}
                </tbody>
              </table>
              {/* <h3 className='pt-md-3'>{cardData.keyword + " Rates"}</h3>
              <BusRatesTable /> */}

              <div id="why-choose-section" className="why-choose-section">


                {/* Section Title */}
                <h2 className="section-title">
                  Why Choose <span>Sai Trupti Cabs</span>
                </h2>

                {/* Cards */}
                <div className="cards-grid">
                  {cardData.whychoose.map((item, index) => (
                    <div key={index} className="why-card">
                      <div className="icon-circle">{index + 1}</div>
                      <h4 className="card-heading">{item.WhyChooseheading}</h4>
                      <p className="card-desc">{item.WhyChoosedescription}</p>
                    </div>
                  ))}
                </div>
              </div>



              <div className="row twm-faq-section-1 m-b30">


                <div className=" col-md-12 wow fadeInDown" data-wow-delay="0.2">
                  <div className="twm-faq-info-wrap">

                    <div className="section-head left">
                      <h2 className="twm-large-title site-text-dark">FAQS {cardData.keyword} For Sai Trupti Cabs </h2>
                    </div>


                    <div className="twm-faq-info">
                      <div className="accordion twm-acdn" id="sf-faq-accordion">

                        <FaqSection
                          title="Frequently Asked"
                          subtitle="Help & Info"
                          items={faqData}
                        />

                      </div>
                    </div>
                  </div>
                </div>
              </div>

              <TestimonialSectionKeyword
                testimonials={testimonials}
              />


              <ContactShowcase />
            </div>

            <div className='col-12 col-md-4' >
              <div className="routeList">
                {Images.map((e, i) => {
                  const isExternal = typeof e.link === "string" && /^https?:\/\//i.test(e.link);
                  const href = isExternal ? e.link : `/${String(e.link || "").replace(/^\/+/, "")}`;

                  return (
                    <a
                      key={e.link || i}
                      href={href}
                      className="routeItem"
                      aria-label={e.text}
                      {...(isExternal ? { target: "_blank", rel: "noopener noreferrer" } : {})}
                    >
                      <div className="routeThumb">
                        <img src={e.place} alt="" loading="lazy" />
                      </div>

                      <div className="routeMeta">
                        <h6 className="routeTitle">{e.text}</h6>
                        <span className="routeUnderline" />
                      </div>

                      <span className="routeArrow" aria-hidden>›</span>
                    </a>
                  );
                })}
              </div>




              <div>
                <FleetHighway />
              </div>
              <div className="pc-contact">
                <h4 className="pc-title">Contact Information</h4>

                <div className="pc-grid">
                  {/* Phones */}
                  <section className="pc-tile">
                    <header className="pc-tile-head">
                      <i className="bi bi-telephone-fill"></i>
                      <span>Phone Numbers</span>
                    </header>

                    <div className="pc-list">
                      <a href="tel:+918390907004" className="pc-call">+91 8390907004</a>
                      <a href="tel:+919922727744" className="pc-call">+91 9922727744</a>
                    </div>

                    <div className="pc-cta">
                      <a
                        href="https://wa.me/918390907004"
                        target="_blank" rel="noopener noreferrer"
                        className="pc-whats"
                      >
                        <i className="bi bi-whatsapp me-1"></i> WhatsApp
                      </a>
                      <a href="tel:+918390907004" className="pc-primary">
                        Call Now
                      </a>
                    </div>
                  </section>

                  {/* Email */}
                  <section className="pc-tile">
                    <header className="pc-tile-head">
                      <i className="bi bi-envelope-fill"></i>
                      <span>Email</span>
                    </header>

                    <a href="mailto:booking@saitrupticabs.com" className="pc-email">
                      booking@saitrupticabs.com
                    </a>
                  </section>

                  {/* Address */}
                  <section className="pc-tile">
                    <header className="pc-tile-head">
                      <i className="bi bi-house-fill"></i>
                      <span>Address</span>
                    </header>

                    <address className="pc-address">
                      <strong>Sai Trupti Cabs </strong><br />
                      Yashoda splendid Park,
                      Office number D. Wing Dudulgaon Anandi,
                        ruial Sainath Chowk Alandi-412105
                    </address>
                  </section>
                </div>
              </div>


            </div>
          </div>
        </div>
      </section>


    </div>
  );
}

export default Punetomahabalehswarcabs;